import has from 'lodash/has';
import axios from 'axios';
import * as types from '../constants/ActionTypes';

// Helpers.
import { docTypeOptions } from '../../lib/customFields';
import { trackSetUp } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import { searchType, searchParser, getFullSearchCount, searchAnalytics } from '../../lib/insightHelper';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const SEARCH_ARTICLE_API_URL = '/smarthelp/related-article';

function requestArticleSearch() {
  return {
    type: types.REQUEST_ARTICLE_SEARCH,
    payload: undefined,
  };
}

function receiveArticleSearchResult(searchTerm, experience, responseData, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_RESPONSE,
    payload: {
      q: searchTerm,
      experience,
      items: responseData,
      channel: documentType,
    },
  };
}

function receiveArticleSearchError(searchTerm, experience, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_ERROR,
    payload: {
      q: searchTerm,
      experience,
      channel: documentType,
    },
  };
}

function fetchArticleSearchResult(searchTerm, experience, channel) {
  const documentType = (has(docTypeOptions, channel)) ? channel : 'faq';
  const trackLinkOption = {
    id: 'searchPage',
    link: `smarthelp-search-filter-document-type|${documentType}`,
    srch: searchTerm,
  };
  const articleSearchUrl = `${SEARCH_ARTICLE_API_URL}?q=${Page.getSanitizedValue(searchTerm)}&exp=${experience}&channel=${documentType}`;

  return (dispatch, getState) => {
    dispatch(requestArticleSearch());
    return axios.get(articleSearchUrl, {
      cancelToken: source.token,
    })
      .then((response) => {
        // Speech to text search key identifier update
        const speechQuery = (getState().speechRecognition || {}).query;
        if (speechQuery) {
          trackLinkOption.srch = `${searchTerm}|speech`;
        }

        // Search Result page impression event
        trackSetUp(trackLinkOption);
        dispatch(receiveArticleSearchResult(searchTerm, experience, response.data, documentType));
        searchAnalytics(searchParser({ count: getFullSearchCount(response.data), type: searchType.fullSearch, query: searchTerm, csrf: Page.getCSRFtoken() }));
      })
      .catch(() => {
        // Error impression event in the search result page
        trackLinkOption.id = 'searchErrorPage';
        trackLinkOption.link = `smarthelp-error-search|filter-type|${documentType}`;
        trackSetUp(trackLinkOption);
        dispatch(receiveArticleSearchError(searchTerm, experience, documentType));
        searchAnalytics(searchParser({ count: 0, type: searchType.fullSearch, query: searchTerm, csrf: Page.getCSRFtoken() }));
      });
  };
}

function cancelArticleSearchRequest() {
  source.cancel('Article Search request canceled.');
}

module.exports = {
  fetchArticleSearchResult,
  cancelArticleSearchRequest,
};
